export const getInitialMenuForUser = (userType) => {
    // client
    if (userType == 0) return "RayaBot";
    // user
    if (userType == 1) return "supportBot";
    // admin
   
    if (userType == 2) return "adminSupportBot";
    return null;
};